import simple from './simple'

const icon = {
  ...simple,
  borderRadius: `full`,
  bg: `omegaLighter`,
}

export default icon